import { render, staticRenderFns } from "./TankNew.vue?vue&type=template&id=498dc87a"
import script from "./TankNew.vue?vue&type=script&lang=js"
export * from "./TankNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports